module.exports = __webpack_public_path__ + "img/versapay-overview-3.94a7af16.png";